/**
 * A BK-Vorschlag counts as rejected as soon as it has a rejection date - also one
 * that was confirmed first and whose BK cancelled later (docs/plans/
 * care-need-single-agency.md, rule 8). The reject-others gate in
 * AcceptNurseSuggestionForm deliberately asks for more (date, "abgelehnt durch"
 * and reason all filled in) - that's about a *documented* rejection, not this.
 */
export const isSuggestionRejected = (suggestion) => !!(suggestion && suggestion.rejectedAt);

/**
 * A confirmation that still takes up one of the BK-Bedarf's nursesNeeded slots:
 * confirmed, not rejected/cancelled since, and its own care period not over yet.
 */
export const isActiveConfirmation = (suggestion, today = new Date()) =>
    !!suggestion &&
    !!suggestion.confirmedAt &&
    !isSuggestionRejected(suggestion) &&
    (!suggestion.careTill || new Date(suggestion.careTill) >= today);
